export { default } from "./LocationPage";
